class FaqContainer extends CardProduct {
  constructor() {
    super();

    this.navigation = this.querySelector('.js-faq-navigation');
    if (this.navigation) {
      this.categories = this.querySelectorAll('.js-faq-category');
      this.setupNavigation();
      this.initEvent();
    }
  }

  setupNavigation() {
    this.categories.forEach((category) => {
      // Get data
      const categoryAnchor = category.getAttribute('data-anchor');
      const categoryId = category.getAttribute('id');

      // Prepare anchor
      const anchor = document.createElement('a');
      anchor.setAttribute('href', `#${categoryId}`);
      anchor.textContent = categoryAnchor;
      const navItem = document.createElement('li');
      navItem.appendChild(anchor);

      // Append to navigation
      this.navigation.appendChild(navItem);
    });
  }

  initEvent() {
    this.navigation.querySelectorAll('a').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.querySelector(anchor.getAttribute('href'));
        target.scrollIntoView({ behavior: 'smooth' });
      });
    });
  }
}
customElements.define('faq-container', FaqContainer);
